import { Interpolation } from "@emotion/serialize"
import { contentPositionerCss } from "../../shared/styles"
import { Theme } from "gatsby-interface"
import * as React from "react"
import slugify from "slugify"

export interface AnchorSectionProps {
  id?: string
  className?: string
  children: React.ReactNode
}

const divCss = (theme: Theme) =>
  [contentPositionerCss({ theme, isFullWidth: false })] as Interpolation

export function AnchorSection({ id, className, children }: AnchorSectionProps) {
  // first checks to see if this is an anchor section or not, creates a slugified version of the id based on the value given
  return id ? (
    <section
      id={slugify(id.toLowerCase(), { strict: true })}
      className={className}
    >
      <div css={divCss}>{children}</div>
    </section>
  ) : (
    <section className={className}>
      <div css={divCss}>{children}</div>
    </section>
  )
}
